import { render } from "./V2HeroEvents.vue?vue&type=template&id=c7b7a196&scoped=true"
import script from "./V2HeroEvents.vue?vue&type=script&lang=js"
export * from "./V2HeroEvents.vue?vue&type=script&lang=js"

import "./V2HeroEvents.vue?vue&type=style&index=0&id=c7b7a196&scoped=true&lang=css"
import "./V2HeroEvents.vue?vue&type=style&index=1&id=c7b7a196&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7b7a196"]])

export default __exports__